import { useQuery } from "react-query";
import { PaymentButtons, UserRes } from "../types";
import { generateSignedRequestConfig, getBaseUrl, handleResponse } from "../utils";

const useGetShowCancelButton = ({ dispatch, errorText, user, purchaseId, paymentButtons }: { dispatch: any, errorText: string, user: UserRes, purchaseId: string, paymentButtons: PaymentButtons }) => {
    const { apiKey, apiSecret, countryCode, id } = user;

    const config = generateSignedRequestConfig({
        apiKey,
        apiSecret,
        countryCode,
        id,
        method: 'GET',
        url: `${getBaseUrl()}/api/billing/purchase/check/cancel/${purchaseId}`,
    });

    return useQuery<boolean>(
        [
            'getShowCancelButton',
            {
                config
            }
        ],
        () => fetch(config.url, { ...config }).then(res => handleResponse(res)),

        {
            enabled: false,
            onError: (error: any) => {
                if (purchaseId !== '') {
                    console.error('Error getting show cancel button: ', error);
                    dispatch({
                        type: 'ADD_MESSAGE',
                        payload: {
                            dismissable: true,
                            id: new Date().getTime(),
                            text: errorText,
                            timeout: 7,
                            type: 'error',
                        },
                    });
                }
            },
            onSuccess: (data: boolean) => {
                dispatch({
                    type: 'UPDATE_PAYMENT_BUTTONS',
                    payload: {
                        ...paymentButtons,
                        showCancelButton: data,
                    },
                });
            },
            retry: 0,
            staleTime: 0,
            keepPreviousData: false
        }
    );
}

export default useGetShowCancelButton